export default __webpack_public_path__ + "static/media/mc-chart.95599b7e.svg";